import { alternativeProductsCarousel } from "../../../utilities/carouselSlickConfig";
import AlternativeProductsCarouselComponent from "./AlternativeProductsCarouselComponent";
import { getSVGIcon } from "../../../utilities/globalUtilities";

/**
 * @function
 * @description - Initialize the cart alternative products carousel Vue component
 * @param {String} el
 * @param {Object} productsData
 */
const initVueAlternativeProducts = (el, productsData) => {
    if (productsData) {
        const cssClassUnavailableProduct = "ct-alternative-unavailable-product product-out-of-stock";
        const cssClassAvailableProduct = "alternative-product pd-tile-wrap ct-alternative-product-tile-carousel";
        const { resources, originalProduct, alternativeProducts: items, alternativeProductIDs, headerTitle, notAvailableAlternativeProductsMessage } = productsData;
        const itemsNumber = items.length;

        const data = () => {
            return {
                resources,
                originalProduct,
                items,
                cssClassUnavailableProduct,
                cssClassAvailableProduct,
                settings: alternativeProductsCarousel(itemsNumber),
                prevArrow: getSVGIcon("icon-arrow-left"),
                nextArrow: getSVGIcon("icon-arrow-right"),
                cartIcon: getSVGIcon("icon-cart"),
                basketIcon: getSVGIcon("icon-basket"),
                alternativeProductIDs,
                headerTitle,
                notAvailableAlternativeProductsMessage
            };
        };

        new AlternativeProductsCarouselComponent({el, data});
    }
};

export { initVueAlternativeProducts };
